import RestService from "./RestService";


export default class EventsService extends RestService {
    constructor() {
        super('/api/events');
    }
}
